@if (isOpen) {
<div class="modal-overlay" (click)="onCancel()">
  <div class="modal-container" (click)="$event.stopPropagation()">
    <!-- Uploading overlay -->
    @if (isUploading) {
      <div class="uploading-overlay">
        <div class="uploading-content">
          <app-spinner [display]="true" [diameter]="48" aria-label="Uploading"></app-spinner>
          <span class="uploading-text">Uploading document…</span>
        </div>
      </div>
    }

    <div class="modal-header">
      <h2 class="modal-title">Document Upload</h2>
      <button class="close-button" (click)="onCancel()" aria-label="Close modal">
        <span class="material-symbols-outlined">close</span>
      </button>
    </div>

    <div class="modal-content overlay-scroll--custom" appScrollActivity [scrollActivityCustom]="true">
      <div class="modal-content-inner">
        <p class="modal-description">Please upload the file for the necessary document update.</p>

        <div class="upload-wrapper">
          @if (!selectedFile || errorMessage) {
            <div
              class="upload-zone"
              [class.upload-zone--dragging]="isDragging"
              [class.upload-zone--error]="errorMessage"
              (dragover)="onDragOver($event)"
              (dragleave)="onDragLeave($event)"
              (drop)="onDrop($event)"
              (click)="fileInput.click()"
            >
              <span class="material-symbols-outlined upload-icon">upload_file</span>
              <p class="upload-text">
                Drag and drop file here or
                <label class="file-label" (click)="$event.stopPropagation()">
                  <span class="choose-file-text">Choose File</span>
                  <input
                    #fileInput
                    tabindex="0"
                    type="file"
                    class="file-input"
                    [accept]="acceptedFormats"
                    (change)="onFileSelected($event)"
                  />
                </label>
              </p>
            </div>
          }

          @if (errorMessage) {
            <div class="error-message">
              <span class="material-symbols-outlined">error</span>
              <span>{{ errorMessage }}</span>
            </div>
          }

          @if (selectedFile && !errorMessage) {
            <div class="selected-file">
              <div class="file-info">
                <span class="material-symbols-outlined file-icon">description</span>
                <div class="file-details">
                  <span class="file-name">{{ selectedFileName }}</span>
                  <span class="file-size">{{ selectedFileSize }}</span>
                </div>
              </div>
              <button class="remove-file-btn" (click)="removeFile()" type="button">
                <span class="material-symbols-outlined">close</span>
              </button>
            </div>
          }

          <div class="upload-info">
            <span class="upload-info-text">{{ supportedFormatsLabel }} {{ supportedFormatsText }}</span>
            <span class="upload-info-text">Maximum size: 10MB</span>
          </div>
        </div>

        @if (documentTypes.length > 0) {
          <div class="form-group">
            <app-az-selector
              [label]="'Uploaded File'"
              [options]="documentTypes"
              [selectedValue]="selectedDocumentType"
              (selectionChange)="onDocumentTypeChange($event)"
            ></app-az-selector>
          </div>
        }

        @if (showCommentBox) {
          <div class="form-group">
            <span class="form-label">Comments:</span>
            <textarea class="form-textarea" [(ngModel)]="comments" rows="4"></textarea>
          </div>
        }

        <div class="modal-actions">
          <app-az-button
            [label]="'Cancel Upload'"
            [showIcon]="false"
            (click)="onCancel()"
            variant="default"
            [disabled]="isUploading"
          ></app-az-button>
          <app-az-button
            [label]="'Confirm Upload'"
            [showIcon]="false"
            (click)="onConfirm()"
            variant="primary"
            [disabled]="!selectedFile || (documentTypes.length > 0 && !selectedDocumentType) || isUploading"
          ></app-az-button>
        </div>
      </div>
    </div>
  </div>
</div>
}
